/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Reason_Third_Country_UnwiredInputs */



/**
* | output |
* | --- |
* | "Third-country export · not yet wired to the accounting system" |
*
* @param {Partner_Billing_Board_Reason_Third_Country_UnwiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_reason_third_country_unwired = /** @type {((inputs?: Partner_Billing_Board_Reason_Third_Country_UnwiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Reason_Third_Country_UnwiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Drittlandausfuhr · noch nicht an die Buchhaltung angebunden")
	return /** @type {LocalizedString} */ ("Third-country export · not yet wired to the accounting system")
});